import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { auth } from "../firebase"; // Import Firebase auth

const ProtectedAdminRoute = () => {
  const user = auth.currentUser; // Get the currently logged-in user

  return user ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default ProtectedAdminRoute;
